import styled from "styled-components";
import { Button } from "react-bootstrap";

export const BarChart = styled.div`
  height: 100%;
  position: relative;

  .btn-section {
    position: absolute;
    top: 5%;
    left: 5%;
  }
`;

export const ZoomButton = styled(Button)`
  border-radius: ${(props) => (props.side === "left" ? "99em 0 0 99em" : "0 99em 99em 0")};
  border: none;
  padding: 0.5rem;

  background-color: ${(props) => (props.dark ? "var(--primary-light)" : "var(--primary-dark)")};
  color: ${(props) => (props.dark ? "var(--text-primary-light)" : "var(--text-primary-dark)")};

  margin: 0 !important;

  :hover,
  :focus {
    border: none;
    background-color: ${(props) => (props.dark ? "var(--primary-light)" : "var(--primary-dark)")};
    color: ${(props) => (props.dark ? "var(--text-primary-light)" : "var(--text-primary-dark)")};
  }

  :hover {
    background-color: ${(props) =>
      props.dark ? "rgba(var(--primary-light-rgb), 0.8)" : "rgba(var(--primary-dark-rgb), 0.8)"} !important;
  }

  transition: none !important;
`;

export const SSignal = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  z-index: 100;

  .signal {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .signal .text {
    position: absolute;
    font-weight: 700;
    font-size: 3em;
    user-select: none;
    pointer-events: none;
  }

  .signal .text-blue {
    color: var(--primary-dark);
    animation: animate-text-warning 7.5s linear infinite;
  }

  .signal .text span {
    position: absolute;
    top: -125px;
    text-transform: uppercase;
    display: inline-block;
    transform-origin: 0 125px;
  }

  .signal i {
    color: var(--primary-dark);
    font-size: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @keyframes animate-text-warning {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;
